"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSchemaParser = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var dereference_json_schema_1 = require("dereference-json-schema");
var lodash_1 = require("lodash");
var locale_1 = tslib_1.__importDefault(require("../locale"));
var excludeFilters = [
    "page_size",
    "ordering",
    "search",
    "page",
    "cursor",
    "format",
    "starts_with",
    "regex",
    "sideload",
];
var useSchemaParser = function (_a) {
    var rootKey = _a.rootKey, data = _a.data, _b = _a.filtersKey, filtersKey = _b === void 0 ? "" : _b, _c = _a.omit, omit = _c === void 0 ? [] : _c, _d = _a.replacements, replacements = _d === void 0 ? null : _d;
    var _e = (0, react_1.useState)(false), loaded = _e[0], setLoaded = _e[1];
    var _f = (0, react_1.useState)(), schema = _f[0], setSchema = _f[1];
    // @ts-ignore
    (0, react_1.useEffect)(function () {
        var fn = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var results, result_1, filters;
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!loaded) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, dereference_json_schema_1.dereferenceSync)(data)];
                    case 1:
                        results = _c.sent();
                        if (results) {
                            result_1 = {};
                            (0, lodash_1.set)(result_1, "columns", data === null || data === void 0 ? void 0 : data.definitions[rootKey].properties);
                            if (replacements) {
                                replacements.map(function (attachment) {
                                    if (!omit.includes(attachment.key)) {
                                        result_1["columns"][attachment.label] = data === null || data === void 0 ? void 0 : data.definitions[attachment.key];
                                    }
                                });
                            }
                            if (filtersKey) {
                                filters = data === null || data === void 0 ? void 0 : data.paths[filtersKey];
                                if (filters) {
                                    result_1["filters"] = (_b = (_a = filters === null || filters === void 0 ? void 0 : filters.get) === null || _a === void 0 ? void 0 : _a.parameters) === null || _b === void 0 ? void 0 : _b.filter(function (f) { return !excludeFilters.includes(f.name); });
                                }
                                else {
                                    console.error(locale_1.default.unableToLoadFilter);
                                }
                            }
                            setSchema(result_1);
                            setLoaded(true);
                        }
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        fn();
    }, [filtersKey, loaded, replacements, rootKey]);
    return schema;
};
exports.useSchemaParser = useSchemaParser;
//# sourceMappingURL=openapi-schema.js.map